<template>
<el-container class="back">
  <el-aside class="left-bar">
    <div class="row sub-logo">
      <img src="/effect.svg" style="width: 30px; height: 30px"/>
      <span>prompt</span>
    </div>
    <div class="op row" @click="createNewPrompt">
      <el-icon><Plus /></el-icon>
      <span>新建提示词</span>
    </div>
    <!--
    <div style="margin-top: 15px">
      <input style="margin-left:0px;width:150px;height: 30px; border-radius: 12px; border-radius: 8px; border:1px solid lightgray;outline: none; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);"/>
    </div> -->
<!--    <div style="height:60vh; overflow: auto; margin-top:20px">-->
<!--    <div v-for="(prompt, index) in prompts" :key="index" class="info-box row-start" @click="toPromptPage(prompt.prompt_id)">-->
<!--      <el-icon style="font-size: 16px"><Tickets /></el-icon><span style="margin-left: 2px">{{prompt.prompt_name}}</span></div>-->
<!--    </div>-->
  </el-aside>
  <el-container style="flex-grow:1.0;height:100vh;overflow: auto">
      <el-drawer v-model="drawer" title="" :with-header="false">
        <div style="display: flex; flex-direction: column">
          <div v-if="prompt.prompt_id === ''" class="row-start" style="color: black">
            <span style="font-size: 16px; font-weight: bold; color:gray">新建Prompt</span>
          </div>
        <input v-model="prompt.prompt_name"  class="input-plain" placeholder="提示词名称"/>
        <input v-model="prompt.prompt_type"  class="input-plain" placeholder="提示词类型"/>
        <input v-model="prompt.project_name" class="input-plain" placeholder="项目名称"/>
        <input v-model="prompt.prompt_desc"  class="input-plain" placeholder="功能描述"/>
        </div>
        <div class="row-end" style="width: 100%">
        <div class="op row" @click="addPrompt">提交</div>
        </div>
        <div v-if="prompt.prompt_id !== ''" class="row-start" style="color: black; margin-top: 30px">
          <el-icon style="color: gray"><CopyDocument /></el-icon><span style="margin-left: 1px; color:gray">复制</span>
          <span style="margin-left: 5px">ID:</span>
          <span style="font-size: 14px; font-weight: normal; color:gray">{{prompt.prompt_id}}</span>
        </div>
      </el-drawer>
    <div style="display:flex; flex-direction:row; justify-content:flex-start;flex-wrap: wrap; margin-top: 10px; height:max-content;">
      <div v-for="(pt, index) in prompts" :key="index">
        <div class="card">
          <div class="row-between">
            <div v-if="pt.prompt_name !== ''" style="font-weight:normal; color:#262727">{{pt.prompt_name}}</div>
            <div v-if="pt.prompt_name === ''" style="font-weight: normal;color: gray">未注明名称</div>
            <el-icon class="hit" @click="openLoginPrompt(pt)"><Edit /></el-icon>
          </div>
          <div v-if="pt.prompt_desc !== ''"
               class="two-line-text" @click="toPromptPage(pt.prompt_id)">{{pt.prompt_desc}}</div>
          <div v-if="pt.prompt_desc === ''"
               class="two-line-text" @click="toPromptPage(pt.prompt_id)" style="color:red">待补充</div>

          <div class="row-start info-beatu" v-if="pt.project_name !== ''" @click="toPromptPage(pt.prompt_id)">{{pt.project_name}}</div>
          <div class="row-start info-beatu" v-if="pt.project_name === ''" @click="toPromptPage(pt.prompt_id)" style="color: gray">项目名称未知</div>
          <div class="row-end"  @click="toPromptPage(pt.prompt_id)">
            <el-button class="row-center white-button">
              <span style="margin-left:5px">测试验证</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</el-container>
</template>

<script setup>
import {ref, onMounted} from "vue";
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import axios from 'axios';
const drawer = ref(false);
const prompts = ref([]);
const prompt = ref({
  "prompt_id": '',
  "prompt_name": '',
  "prompt_type": '',
  "prompt_desc": '',
  "project_name": '',
  "author": '',
})

const router = useRouter();


const openLoginPrompt = (prom) =>{
  prompt.value = prom;
  drawer.value = true;
}

const createNewPrompt = () =>{
  prompt.value = {
    "prompt_id": '',
    "prompt_name": '',
    "prompt_type": '',
    "prompt_desc": '',
    "project_name": '',
    "author": '',
  }
  drawer.value = true;
}

const addPrompt = async() =>{
  const response = await axios.post('/db/prompt', {
      op: "submit", // 查询参数
      record: JSON.stringify(prompt.value), // 可以添加多个参数
    }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
    );
  console.log(response);
  if (response.data.response != prompt.value.prompt_id){
    prompts.value.push({
      "prompt_id": response.data.response,
      "prompt_name": prompt.value.prompt_name,
      "prompt_type": prompt.value.prompt_type,
      "prompt_desc": prompt.value.prompt_desc,
      "project_name": prompt.value.project_name,
      "author": prompt.value.author,
    });
    ElMessage({
      message: '提示词添加成功',
      type: 'success',
    })
  }else{
    ElMessage({
      message: '提示词已更新',
      type: 'success',
    })
  }

  drawer.value = false;
}

const toPromptPage = (prompt_id) =>{
  // 导航到带有查询参数的路由
  console.log(prompt_id);
  router.push({
    path: '/prompt',
    query: {
      prompt_id: prompt_id
    },
  });
}

onMounted(async () =>{
  const response = await axios.post('/db', {
          op: "query"
     }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(response);
  prompts.value = response.data.response;
})
</script>

<style scoped>

.box{
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
}

.row-between{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.left-bar{
  height:100%;
  padding-left: 15px;
  padding-right:15px;
  display: flex;
  background-color: white;
  box-sizing: border-box;
  width: max-content;
  flex-direction: column;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
}

.card{
  width:300px;
  height:auto;
  position: relative;
  max-height:180px;
  background-color: white;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
  padding:15px;
  margin-left:15px;
  margin-top:15px;
  border-radius: 8px;
  box-sizing: border-box;
}

.card:hover{
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  width:300px;
  height:auto;
  margin-left:15px;
  margin-top:15px;
  border: 2px solid #6467f0;
}

.two-line-text{
  color: gray;
  padding:8px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}

.white-button{
  border: none;
  color: gray;
  font-weight: normal;
}

.white-button:hover{
  border: none;
  background-color: #6467f0;
  color: white;
  border-radius: 30px;
}

.info-beatu{
  background-color: whitesmoke;
  border-radius: 10px 0px 10px 0px;
  padding: 3px 10px;
  border: 1px solid lightgray;
  width: max-content;
  font-size: 12px;
  color: #303030;
}

.hit{
  color:gray
}

.hit:hover{
  color:#6467f0;
}



</style>